import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SearchResultComponent } from '@softapps/core/pages';

@Component({
  selector: 'soft-field-ok-orte-search-result-view',
  imports: [CommonModule],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrteFieldOkSearchResultViewComponent implements SearchResultComponent<any> {
  readonly result = input.required<any>();
}
